import { render } from "./StatusBarChart.vue?vue&type=template&id=2a60270a"
import script from "./StatusBarChart.vue?vue&type=script&lang=js"
export * from "./StatusBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__